import React from 'react';
import {useTranslation} from "react-i18next";
import {useFormik} from "formik";
import {Container, Row, Col} from "react-bootstrap";
import Target from "../../../ui/components/Target/Target";
import Input from "../../../ui/components/Input/Input";

const ServiceWorkForm = ({
    id,
    name,
    cost,
    unit, unitName,
    description,
    service360Id,
    service360Name,
    crmId,
    isBlocked,
    modifiedOn,
    targets,
    disabled,
    onSubmit
}) => {
    const {t} = useTranslation();

    const form = useFormik({
        enableReinitialize: true,
        initialValues: {
            id,
            name,
            cost,
            unit,
            unitName,
            description,
            service360Id,
            service360Name,
            crmId,
            isBlocked,
            modifiedOn,
            targets
        },
        onSubmit
    });

    return (
        <Container fluid>
            <form id='service-work-form' onSubmit={form.handleSubmit}>
                <Row>
                    <Col>
                        <div className='input-container'>
                            <label className='label'>
                                {t("serviceWork.form.name")}
                            </label>
                            <Input name='name'
                                   type='text'
                                   disabled={true}
                                   value={form.values.name ?? ''}/>
                        </div>
                    </Col>
                    <Col>
                        <div className='input-container'>
                            <label className='label'>
                                {t("serviceWork.form.serviceId")}
                            </label>
                            <Input name='service360Name'
                                   type='text'
                                   disabled={true}
                                   value={form.values.service360Name ?? ''}/>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className='input-container'>
                            <label className='label'>
                                CRM ID
                            </label>
                            <Input name='crmId'
                                   type='text'
                                   disabled={true}
                                   value={form.values.crmId ?? ''}/>
                        </div>
                    </Col>
                    <Col>
                        <div className='input-container'>
                            <label className='label'>
                                {t("serviceWork.form.cost")}
                            </label>
                            <Input name='cost'
                                   type='text'
                                   disabled={true}
                                   value={form.values.cost ?? ''}/>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className=''>
                            <label className='label'>
                                {t("serviceWork.form.description")}
                            </label>
                            <textarea className='form-control'
                                      rows={6}
                                      disabled={true}
                                      value={form.values.description ?? ''}
                                      readOnly/>
                        </div>
                    </Col>
                    <Col>
                        <div className='input-container'>
                            <label className='label'>
                                {t("serviceWork.form.unit")}
                            </label>
                            <Input name='unitName'
                                   type='text'
                                   disabled={true}
                                   value={form.values.unitName ?? ''}/>
                        </div>
                    </Col>

                </Row>
            </form>
            <Row style={{marginTop: 20}}>
                <Col>
                    <Target targets={form.values.targets}
                            disabled={disabled || form.isSubmitting}
                            change={(items) => form.setFieldValue('targets', items)}/>
                </Col>
            </Row>
        </Container>
    );
};

export default ServiceWorkForm;

